export default "__VITE_ASSET__DINhSiTS__"